/* istanbul ignore file */
import { useBaseCrudService } from 'framework/crud';
import employeeFeedbackValidation from 'domain/people/employee/Timeline/feedback/form/employeeFeedbackValidation';
import { useKernelApi } from 'infrastructure/api';
import employeeFeedbackFlagValidation from 'domain/people/employee/Timeline/feedback/form/employeeFeedbackFlagValidation';
import { FormFieldsData } from 'framework/form';

export const CREATE_EMPLOYEE_FEEDBACK = 'CREATE_FEEDBACK';
export const UPDATE_EMPLOYEE_FEEDBACK = 'UPDATE_FEEDBACK';

const useEmployeeFeedbackService = () => {
  const { sendPatchRequest } = useKernelApi();

  const { update } = useBaseCrudService({
    listResourceUrl: '/feedbacks',
    singleResourceUrl: '/feedbacks/:id',
    useService: useKernelApi,
  });

  const updateFlag = async (feedbackId: any, data: FormFieldsData) => {
    const result = await sendPatchRequest(`/feedbacks/${feedbackId}`, data);
    return result.json();
  };

  const getValidationSchema = () => Promise.resolve(employeeFeedbackValidation);

  const getFlagValidationSchema = () => Promise.resolve(employeeFeedbackFlagValidation);

  return {
    getValidationSchema,
    update,
    updateFlag,
    getFlagValidationSchema,
  };
};

export default useEmployeeFeedbackService;
